import React, { useState, useEffect, useCallback } from 'react'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import SupportWidget from '@/components/support/SupportWidget'
import CycleLaunchAlert from './CycleLaunchAlert'

interface LayoutProps {
  children: React.ReactNode
}

export function Layout({ children }: LayoutProps) {
  const [isMobile, setIsMobile] = useState(false)
  const [sidebarOpen, setSidebarOpen] = useState(false)

  useEffect(() => {
    const mql = window.matchMedia('(max-width: 767px)')
    const handleChange = (e: MediaQueryListEvent | MediaQueryList) => {
      setIsMobile(e.matches)
      if (!e.matches) setSidebarOpen(false)
    }
    handleChange(mql)
    mql.addEventListener('change', handleChange)
    return () => mql.removeEventListener('change', handleChange)
  }, [])

  const handleMenuClick = useCallback(() => setSidebarOpen(true), [])
  const handleSidebarClose = useCallback(() => setSidebarOpen(false), [])

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Desktop: inline sidebar */}
      {!isMobile && <Sidebar />}
      {/* Mobile: drawer sidebar */}
      {isMobile && (
        <Sidebar isMobile isOpen={sidebarOpen} onClose={handleSidebarClose} />
      )}
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header onMenuClick={isMobile ? handleMenuClick : undefined} />
        <main className="flex-1 overflow-y-auto px-3 pb-3 sm:px-4 sm:pb-4 md:px-6 md:pb-6">
          {/* A check-in cycle HR has opened (HR UAT list #23) */}
          <CycleLaunchAlert />
          {children}
        </main>
      </div>

      {/* Global Support & Suggestions Widget */}
      <SupportWidget />
    </div>
  )
}
